import { apiClient } from "~/services/apiClient";

export async function getSipCredentials() {
  const response = await apiClient.get("/sip/credentials");
  return response.data;
}
